import './MoreStats.css';

/**
 * The secondary numbers on My Progress, collapsed by default. Anything the
 * summary already shows (percent, unique chapters, streak, books) stays out.
 */
const MoreStats = ({ stats, derived, profile, singleReader }) => {
  const { totalReports, uniqueChaptersRead, bulkChapters = 0 } = stats;
  const reReads = Math.max(0, totalReports - uniqueChaptersRead);
  const biblesCompleted = profile?.stats?.completedBibles ?? 0;

  const rows = [];
  // At one or more it is a chip in the summary instead.
  if (singleReader && profile && biblesCompleted === 0) {
    rows.push({ label: 'Bible completions', value: 0 });
  }
  if (derived.challengeChapters != null) {
    rows.push({ label: 'Chapters this challenge', value: derived.challengeChapters.toLocaleString() });
  }
  rows.push({ label: 'Logged chapter by chapter', value: totalReports.toLocaleString() });
  rows.push({ label: 'Re-reads', value: reReads.toLocaleString() });
  if (bulkChapters > 0) {
    rows.push({ label: 'Logged as bulk totals', value: bulkChapters.toLocaleString() });
  }

  return (
    <details className="more-stats">
      <summary>More stats</summary>
      <dl>
        {rows.map((row) => (
          <div key={row.label} className="more-stats-row">
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>
      {bulkChapters > 0 && (
        <p className="more-stats-note">
          Bulk totals count toward chapters read but not the percentages or the map,
          since they don't say which chapters were read.
        </p>
      )}
    </details>
  );
};

export default MoreStats;
